<ion-content class="bg-color ion-content integration-details">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="content-grid" [ngClass]="{'no-about': noAbout == true}">
      <mat-stepper class="create-stepper" labelPosition="bottom" [@.disabled]="true"
        [orientation]="(stepperOrientation | async)!" (selectionChange)="selectionChange($event)">
        <mat-step [stepControl]="dataSource" [completed]="false">
          <form [formGroup]="dataSource" >
            <ng-template matStepLabel>Data Source</ng-template>
            <mat-card class="m-card source">
              <mat-card-title class="m-title">
                <span class="m-header">Data Source Type</span>
              </mat-card-title>
              <div class="m-body">
                <mat-label>Source Type</mat-label>
                <mat-form-field class="data-column" appearance="fill">
                  <input type="text" id="dsType" matInput formControlName="bridge_source_type">
                </mat-form-field>
              </div>
            </mat-card>
            <mat-card class="m-card source" *ngIf="bridge_source_type == 1">
              <mat-card-title class="m-title">
                <span class="m-header">Data Source Information</span>
              </mat-card-title>
              <div class="m-body">
                <mat-label>Data Source</mat-label>
                <mat-form-field class="data-column" appearance="fill">
                  <input type="text" id="ib_details_source_type" matInput formControlName="bridge_source">
                </mat-form-field>

                <mat-label *ngIf="isNewSource">Enter Product Name</mat-label>
                <mat-form-field style="margin-top: 15px;" appearance="fill" *ngIf="isNewSource">
                  <input type="text" formControlName="new_bridge_source" id="ib_details_source_enter_source_name"
                    matInput placeholder="Product name" required>
                </mat-form-field>

                <mat-label *ngIf="isNewSource">Enter Business Object</mat-label>
                <mat-form-field appearance="fill" *ngIf="isNewSource">
                  <input type="text" formControlName="new_bridge_source_business_object"
                    id="ib_details_source_enter_businessObj" matInput placeholder="Business object" required>
                </mat-form-field>

                <mat-label *ngIf="!isNewSource">Business Object</mat-label>
                <mat-form-field class="source-businessObj" appearance="fill" *ngIf="!isNewSource">
                  <input type="text" matInput formControlName="bridge_source_business_object"
                    id="ib_details_source_select_businessObj">
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card class="m-card data-source-postman" *ngIf="bridge_source_type == 1">
              <div class="m-body">
                <div class="views-content-data">
                  <div class="data-options-view">
                    <mat-form-field class="data-options-dropdown-view" appearance="fill">
                      <input type="text" matInput formControlName="bridge_source_endpoint_method"
                        id="ib_details_source_request_method">
                    </mat-form-field>
                  </div>
                  <div class="data-url-view">
                    <mat-form-field class="data-url-view" appearance="fill">
                      <textarea class="input-url-view" rows="1" matInput placeholder="Request URL"
                        id="ib_details_source_endpoint_request_url"
                        formControlName="bridge_source_endpoint_url"></textarea>
                    </mat-form-field>
                  </div>
                </div>

                <mat-tab-group animationDuration="0ms" class="views-options-data-group"
                  (selectedTabChange)="sourcePostmanTabChange($event)">
                  <mat-tab label="Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_endpoint_params_raw"
                            *ngFor="let params of bridgeSourceParams?.controls;let i = index">
                            <ng-container class="data-options-field" [formGroupName]="i">
                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_source_paramKey" matInput placeholder="Key"
                                  id="ib_details_source_endpoint_params_key" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_source_paramValue" matInput
                                  id="ib_details_source_endpoint_params_value" placeholder="Value" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_source_paramDescription" matInput
                                  id="ib_details_source_endpoint_params_desc" placeholder="Description"
                                  [readonly]="true">
                              </mat-form-field>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Authorization">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="authentication-view">
                          <div class="view-options-drop">
                            <mat-label>OAuth Type</mat-label>
                            <mat-form-field class="mat-dropdown" appearance="fill">
                              <input type="text" matInput formControlName="bridge_source_endpoint_authentication_type"
                                id="ib_details_source_endpoint_authentication_type">
                            </mat-form-field>
                          </div>

                          <div class="view-body">
                            <ng-container *ngIf="selectSourceType == 3">
                              <div class="view-options">
                                <mat-label>Token</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Token"
                                    id="ib_details_source_endpoint_authentication_token"
                                    formControlName="bridge_source_authentication_token">
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectSourceType == 4">
                              <div class="view-options">
                                <mat-label>Username</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Username"
                                    [type]="isHidden ? 'password' : 'text'"
                                    id="ib_details_source_endpoint_authentication_username"
                                    formControlName="bridge_source_authentication_username">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Password</mat-label>
                                <mat-form-field appearance="fill">
                                  <input matInput placeholder="Password" [type]="isHidden ? 'password' : 'text'"
                                    id="ib_details_source_endpoint_authentication_password"
                                    formControlName="bridge_source_authentication_password">
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectSourceType == 6">
                              <div class="view-options-drop">
                                <mat-label>Refresh Token Method</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token Endpoint Method"
                                    id="ib_details_source_endpoint_authentication_method"
                                    formControlName="bridge_source_oauth_refresh_token_endpoint_method">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token URL</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token Endpoint URL"
                                    id="ib_details_source_endpoint_url"
                                    formControlName="bridge_source_oauth_refresh_token_endpoint_url" [readonly]="true">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token Header</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token Endpoint Header"
                                    id="ib_details_source_endpoint_authentication_header"
                                    formControlName="bridge_source_oauth_refresh_token_endpoint_header">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token Params</mat-label>
                                <mat-form-field style="width: 100%;" appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token Params"
                                    id="ib_details_source_endpoint_authentication_params"
                                    formControlName="bridge_source_oauth_refresh_token_endpoint_params">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token Body</mat-label>
                                <mat-form-field style="width: 100%;" appearance="fill">
                                  <textarea matInput cdkTextareaAutosize rows="5" placeholder="Refresh Token Body"
                                    id="ib_details_source_endpoint_authentication_body"
                                    formControlName="bridge_source_oauth_refresh_token_endpoint_body"></textarea>
                                </mat-form-field>
                              </div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Headers">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_endpoint_headers"
                            *ngFor="let headers of bridgeSourceHeaders?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_source_headerKey" matInput placeholder="Key"
                                  id="ib_details_source_endpoint_header_key" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_source_headerValue" matInput
                                  id="ib_details_source_endpoint_header_value" placeholder="Value" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_source_headerDescription" matInput
                                  id="ib_details_source_endpoint_header_desc" placeholder="Description"
                                  [readonly]="true">
                              </mat-form-field>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Body">
                    <div class="mat-section">
                      <div style="width: 25%;">
                        <mat-label>Select Type</mat-label>
                        <mat-form-field class="mat-dropdown" appearance="outline">
                          <mat-select formControlName="bridge_source_body_type"
                            id="ib_details_source_endpoint_body_type">
                            <mat-option *ngFor="let type of bodyTypeOptions" [value]="type.type">
                              {{ type.type }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="m-body">
                        <ngx-codemirror formControlName="bridge_source_endpoint_body_raw"
                          id="ib_details_source_endpoint_body_raw" #bodySourceEditor
                          [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Pre-request Script">
                    <div class="mat-section">
                      <div class="m-body-script">
                        <!-- <json-editor class="disable-json" [options]="editorSourceOptions">
                        </json-editor> -->
                        <!-- <ngx-monaco-editor formControlName="pre_request_script" [options]="editorSourceOptions2"
                          (init)="editorInit($event)">
                        </ngx-monaco-editor> -->

                        <ngx-codemirror formControlName="pre_request_script"
                          id="ib_details_source_endpoint_pre_request_script" #sourcePreRequestScriptEditor
                          [options]="preRequestScriptEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Pagination">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="authentication-view">
                          <div class="view-options">
                            <mat-label>Select Type</mat-label>
                            <mat-form-field class="mat-dropdown" appearance="fill">
                              <input type="text" matInput formControlName="bridge_source_pagination_type"
                                id="ib_details_source_endpoint_pagination_type">
                            </mat-form-field>
                          </div>

                          <div class="view-body">
                            <ng-container *ngIf="selectPaginationType == 2">
                              <div class="view-options">
                                <mat-label>User Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_2"
                                    id="ib_details_source_endpoint_user_key2" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Data Collection Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_details_source_endpoint_response_paramters2"
                                    formControlName="response_parameters_2" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options"
                                *ngIf="integrationObj?.another_response_parameter != '' &&  integrationObj?.another_response_parameter != undefined">
                                <mat-label>Another Response Parameter</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Another Response Parameter"
                                    id="ib_details_source_endpoint_another_response_parameters2"
                                    formControlName="another_response_parameter_2">
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 3">
                              <div class="view-options">
                                <mat-label>User Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_3"
                                    id="user_key_3" id="ib_details_source_endpoint_user_key3" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Key Name to Update</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Key Name to Update"
                                    id="ib_details_source_endpoint_key_name_to_update_3"
                                    formControlName="key_name_to_update_3" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Data Collection Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_details_source_endpoint_response_parameters_3"
                                    formControlName="response_parameters_3" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 4">
                              <div class="view-options">
                                <mat-label>User Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_4"
                                    id="ib_details_source_endpoint_user_key4" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Key Name to Update</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Key Name to Update"
                                    id="ib_details_source_endpoint_key_name_to_update_4"
                                    formControlName="key_name_to_update_4" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Data Collection Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_details_source_endpoint_response_parameters_4"
                                    formControlName="response_parameters_4" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 5">
                              <div class="view-options">
                                <mat-label>User Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_5"
                                    id="ib_details_source_endpoint_user_key5" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Key Name to Update</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Key Name to Update"
                                    id="ib_details_source_endpoint_key_name_update5"
                                    formControlName="key_name_to_update_5" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Data Collection Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_details_source_endpoint_response_parameters_5"
                                    formControlName="response_parameters_5" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 6">
                              <div class="view-options">
                                <mat-label>User Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_6"
                                    id="ib_details_source_endpoint_user_key6" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>User Key URL</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="User Key URL"
                                    id="ib_details_source_endpoint_user_keyUrl6" formControlName="user_key_url_6"
                                    required>
                                  <!-- <input type="text" matInput placeholder="Refresh Token Endpoint Method" formControlName="bridge_source_oauth_refresh_token_endpoint_method"> -->
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Data Collection Key</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_details_source_endpoint_response_parameters_6"
                                    formControlName="response_parameters_6" required>
                                </mat-form-field>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="selectPaginationType == 7">
                              <div class="view-options">
                                <mat-label>User Key</mat-label>
                                <mat-form-field appearance="outline">
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_7"
                                    id="ib_details_source_endpoint_user_key7" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Data Collection Key</mat-label>
                                <mat-form-field appearance="outline">
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_details_source_endpoint_response_parameters_7"
                                    formControlName="response_parameters_7" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="selectPaginationType == 8">
                              <div class="view-options">
                                <p>Custom Pagination Script</p>
                                <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                                  <ngx-codemirror formControlName="custom_pagination_script"
                                    #sourceCustomPaginationScriptEditor (keydown.enter)="$event.preventDefault()"
                                    [options]="codeMirrorEditorOptions">
                                  </ngx-codemirror>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Numeric Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="authentication-view">
                          <div class="view-body">
                            <ng-container>
                              <div class="view-options">
                                <mat-label>Minimun Number</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="number" matInput placeholder="Enter min number"
                                    id="ib_details_source_numeric_params_min" formControlName="min_number">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Maximum Number</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="number" matInput placeholder="Enter max number"
                                    id="ib_details_source_numeric_params_max" formControlName="max_number">
                                </mat-form-field>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Time Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="authentication-view">
                          <div class="view-body">
                            <ng-container>
                              <div class="view-options">
                                <mat-label>Today Format</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput formControlName="today_str" required
                                    id="ib_details_source_time_params_today">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Yesterday Format</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput formControlName="yesterday_str"
                                    id="ib_details_source_time_params_yesterday" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Rolling Time Format</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput formControlName="rolling_time_format"
                                    id="ib_details_source_time_params_rolling_time" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Rolling Frquency</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="number" matInput formControlName="rolling_frequency"
                                    id="ib_details_source_time_params_rolling_frequency" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Time Offset Value</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="number" matInput formControlName="offset_value"
                                    id="ib_details_source_time_params_offset_value" required>
                                </mat-form-field>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_source_type == 2">
              <div class="ops-form-body" *ngIf="isjdbcSourceFromEnabled">
                <mat-card class="m-card data-source">
                  <div class="m-body">
                    <div class="data-btn">
                      <label class="ops-lab-data-target">Storage Details</label>
                    </div>
                    <mat-label>Select Storage Name</mat-label>
                    <mat-form-field appearance="fill">
                      <input matInput type="text" formControlName="storage_name" id="ib_details_source_storage_name"
                        readonly>
                    </mat-form-field>
                    <mat-label>Select Version</mat-label>
                    <mat-form-field appearance="fill">
                      <input matInput type="text" formControlName="db_version" id="ib_details_source_dbVersion"
                        readonly>
                    </mat-form-field>
                    <mat-label>Host IP</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="host_ip" matInput placeholder="Host IP"
                        id="ib_details_source_host" readonly>
                    </mat-form-field>
                    <mat-label>Port Number</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="port_number" matInput id="ib_details_source_portNo" readonly>
                    </mat-form-field>
                    <mat-label>Schema Name</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="schema_name" matInput id="ib_details_source_schema" readonly>
                    </mat-form-field>
                    <mat-label>User Name</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="username" matInput id="ib_details_source_usrename" readonly>
                    </mat-form-field>
                    <mat-label>Password</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="password" formControlName="password" matInput id="ib_details_source_password"
                        readonly>
                    </mat-form-field>
                    <mat-label>Chunks Size</mat-label>
                    <mat-form-field appearance="outline">
                      <input type="number" formControlName="chunks_size" id="ib_details_source_chunks-size" matInput>
                    </mat-form-field>
                    <mat-label>Response Parameter</mat-label>
                    <mat-form-field appearance="outline">
                      <input type="text" formControlName="response_parameter"
                        id="ib_details_source_db_response_parameters" matInput>
                    </mat-form-field>
                    <!-- <mat-form-field appearance="fill">
                      <mat-label>Batch Size</mat-label>
                      <input type="text" formControlName="batch_size" matInput readonly>
                    </mat-form-field> -->
                    <mat-card class="mat-section detail" style="border:1px groove;border-radius: 5px;">
                      <p style="margin-left: 10px;color:#bdbdbd !important">SQL Statement</p>
                      <div class="m-body-script">
                        <ngx-codemirror formControlName="query" id="ib_details_source_db_query" #queryEditor
                          [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                        <!-- <textarea matInput cols="100" rows="8" cdkTextareaAutosize  id="ib_details_source_db_query" formControlName="query" style="color: #bbbbbb;"></textarea> -->
                      </div>
                    </mat-card>
                    <div class="res-container">
                      <div class="res-header">
                        <span class="res-header">Response</span>
                        <span *ngIf="data_target_status">
                          <span class="res-status" *ngIf="data_target_status">Status:
                            <strong>{{data_target_status}}</strong></span>
                        </span>
                      </div>
                    </div>
                    <mat-card class="mat-section" style="border:1px groove;border-radius: 5px;">
                      <div class="m-body-script">
                        <!-- <ngx-monaco-editor formControlName="response" [options]="editorPycodeOption"
                          (init)="jdbcResponseeditorInit($event)">
                        </ngx-monaco-editor> -->
                        <!-- <textarea matInput cols="100" rows="8" cdkTextareaAutosize  id="ib_details_source_db_response" formControlName="response" style="color: #bbbbbb;"></textarea> -->
                        <ngx-codemirror formControlName="response" id="ib_details_source_db_response"
                          #queryresponseEditor [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </mat-card>
                  </div>
                </mat-card>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_source_type == 3">
              <div class="ops-form-body">
                <mat-card class="m-card data-source">
                  <div class="m-body">
                    <mat-label>Data Lake Version</mat-label>
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <input matInput formControlName="version" id="ib_details_source_dl_version" type="text" readonly>
                    </mat-form-field>
                    <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;">
                      <div>
                        <p style="margin-top:25px">
                          <span style="background: #ddd;">bizintel360-</span>
                        </p>
                      </div>
                      <div>
                        <mat-form-field appearance="outline" style="width: 55%;">
                          <mat-label class="bold-label">Index / Table Name</mat-label>
                          <input type="text" matInput formControlName="dlsource_index_name"
                            id="ib_details_source_dl_index_name" readonly>
                        </mat-form-field>
                      </div>
                    </div>
                    <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Pagination Wait Time</mat-label>
                      <input type="text" matInput formControlName="scroll" id="ib_details_source_dl_scroll" readonly>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Timeout</mat-label>
                      <input type="text" matInput formControlName="dlsource_timeout" id="ib_details_source_dl_timeout"
                        readonly>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Size</mat-label>
                      <input type="text" matInput formControlName="dlsource_batch_size"
                        id="ib_details_source_dl_batch_size" readonly>
                    </mat-form-field>
                    <!-- <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Query</mat-label>
                      <textarea type="text" matInput formControlName="dlsource_body" id="ib_details_source_dl_body"
                        readonly></textarea>
                    </mat-form-field> -->
                    <mat-card class="mat-section" style="border:1px groove;border-radius: 5px;">
                      <p style="margin-left: 10px;">Query</p>
                      <div class="m-body-script">
                        <ngx-codemirror formControlName="dlsource_body" #dlSearchEditor
                          [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>

                    </mat-card>
                  </div>
                </mat-card>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_source_type == 4">
              <div class="m-body">
                <div class="views-content-data-ws">
                  <div class="data-url">
                    <mat-form-field class="data-url" appearance="outline">
                      <input type="text" matInput placeholder="Request URL" id="ib_details_source_ws_endpoint_url"
                        formControlName="bridge_source_ws_endpoint_url" (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>
                  </div>

                </div>
                <mat-tab-group animationDuration="0ms" class="views-options-data-group"
                  [(selectedIndex)]="indexSelectionWebsocket" (selectedTabChange)="sourcePostmanWsTabChange($event)">
                  <mat-tab label="Message">
                    <div class="mat-section">
                      <div class="m-body-script">
                        <ngx-codemirror formControlName="bridge_source_ws_message" #sourceMessageEditor
                          id="ib_details_source_ws_endpoint_message" [options]="messageEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_ws_endpoint_params_raw"
                            *ngFor="let params of bridgeSourceWsParams?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_paramKey"
                                  id="ib_details_source_ws_endpoint_params_key{{i}}" matInput placeholder="Key"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_paramValue"
                                  id="ib_details_source_ws_endpoint_params_value{{i}}" matInput placeholder="Value"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_paramDescription"
                                  id="ib_details_source_ws_endpoint_params_desc{{i}}" matInput placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Headers">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_ws_endpoint_headers"
                            *ngFor="let headers of bridgeSourceWsHeaders?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_headerKey" matInput
                                  id="ib_details_source_ws_endpoint_header_key{{i}}" placeholder="Key"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_headerValue" matInput
                                  id="ib_details_source_ws_endpoint_header_value{{i}}" placeholder="Value"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_headerDescription" matInput
                                  id="ib_details_source_ws_endpoint_header_desc{{i}}" placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>


            </mat-card>
            <mat-card class="m-card data-source" *ngIf="bridge_source_type == 5">
              <div class="m-body">
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Email</mat-label>
                  <input type="text" matInput formControlName="user_email" id="ib_detail_source_user_email"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Password</mat-label>
                  <input type="password" matInput formControlName="password" id="ib_detail_source_email_password"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Mail Server</mat-label>
                  <input type="text" matInput formControlName="mail_server" id="ib_detail_source_email_mailServer"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Port Number</mat-label>
                  <input type="text" matInput formControlName="port_number" id="ib_detail_source_email_port"
                    (keydown.enter)="$event.preventDefault()" pattern="^[0-9]+$">
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Output Type</mat-label>
                  <mat-select formControlName="out_type" id="ib_detail_source_out_type">
                    <mat-option *ngFor="let obj of email_out_types" [value]="obj.value" selected>{{obj.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card>
            <div class="action-btn-section">
              <button mat-stroked-button class="next" id="ib_details_source_dl_cancel"
                routerLink="/baseapp/integration">Cancel</button>
              <button mat-stroked-button matStepperNext id="ib_details_source_dl_next" class="next">
                Next<mat-icon matSuffix>east</mat-icon>
              </button>
              <button mat-stroked-button matStepperPrevious id="ib_details_source_dl_go_back"
                routerLink="/baseapp/integration" class="previous">
                <mat-icon matSuffix>west</mat-icon>Go Back
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="dataOperations" [completed]="false">
          <ng-template matStepLabel>Data Operations</ng-template>
          <mat-card class="m-card operations" cdkDropListGroup>
            <mat-card-content class="m-body">
              <ng-container *ngIf="blocks.length  == 0">
                <div class="timeline" cdkDropList #blocksList="cdkDropList">
                  <p class="drop-ops-text">No Data Operations Found</p>
                </div>
              </ng-container>

              <ng-container *ngIf="blocks.length  > 0">
                <div class="timeline">
                  <ng-container *ngFor="let row of newBlocks; let i=index">
                    <div class="row" [ngClass]='i%2? "row-reverse": ""'>
                      <ng-container *ngFor="let col of newBlocks[i]; let j = index">
                        <div class="operations" cdkDropList #blocksList="cdkDropList">
                          <div *ngIf="i%2 != 0 && j == 2 && j > 0" class="left-u-bend"></div>
                          <div *ngIf="i%2 == 0 && j == 2 && j > 0" class="right-u-bend"></div>
                          <div class="circle" *ngIf="col.isValid && !col?.isMute"
                            [class.active]='selectedOperationId === col.id' (click)="openForm(col.title, col.id)">
                            <span class="ops-title-up">{{ col.title | uppercase }}</span>
                            <span class="ops-title-count">{{ col?.count }}</span>
                          </div>
                          <div class="circle" *ngIf="col?.isMute && selectedOperationId !== col.id"
                            [class.isMute]="col.isMute && selectedOperationId !== col.id"
                            (click)="openForm(col.title, col.id)">
                            <span class="ops-title-up">{{ col.title | uppercase }}</span>
                            <span class="ops-title-count">{{ col?.count }}</span>
                          </div>
                          <div class="circle" *ngIf="col.isMute && selectedOperationId === col.id"
                            [class.isMuteActive]="col.isMute && selectedOperationId === col.id"
                            (click)="openForm(col.title, col.id)">
                            <span class="ops-title-up">{{ col.title | uppercase }}</span>
                            <span class="ops-title-count">{{ col?.count }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <form [formGroup]="bizdata_ops_datatypes_fb" *ngIf="isDataTypeFromEnabled">
                <div formArrayName="datatypesRows">
                  <div class="ops-form" *ngFor="let fo of datatypesRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data Types</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_datatypes_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_append_fb" *ngIf="isAppendFromEnabled">
                <div formArrayName="appendRows">
                  <div class="ops-form" *ngFor="let fo of appendRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Append</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_append_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cdkTextareaAutosize cols="100" rows="8"
                              [formControlName]="operation"></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_uppercase_fb" *ngIf="isUppercaseFromEnabled">
                <div formArrayName="uppercaseRows">
                  <div class="ops-form" *ngFor="let fo of uppercaseRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Uppercase</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_uppercase_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_titlecase_fb" *ngIf="isTitlecaseFromEnabled">
                <div formArrayName="titlecaseRows">
                  <div class="ops-form" *ngFor="let fo of titlecaseRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Titlecase</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_titlecase_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_lowercase_fb" *ngIf="isLowercaseFromEnabled">
                <div formArrayName="lowercaseRows">
                  <div class="ops-form" *ngFor="let fo of lowercaseRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Lowercase</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_lowercase_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dataextractor_fb" *ngIf="isData_extractorFromEnabled">
                <div formArrayName="dataextractorRows">
                  <div class="ops-form" *ngFor="let fo of dataextractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data Extractor</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dataextractor_obj;let i=index">
                          <mat-form-field appearance="fill" *ngIf="operation != 'data_extractor_keys'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea cols="100" rows="8" matInput cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="operation == 'data_extractor_keys'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea cols="100" rows="8" matInput cdkTextareaAutosize
                              [formControlName]="operation"></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_trim_fb" *ngIf="isTrimFromEnabled">
                <div formArrayName="trimRows">
                  <div class="ops-form" *ngFor="let fo of trimRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Trim</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_trim_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_json2string_fb" *ngIf="isJson2stringFromEnabled">
                <div formArrayName="json2stringRows">
                  <div class="ops-form" *ngFor="let fo of json2stringRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to String</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json2string_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_string2json_fb" *ngIf="isString2jsonFromEnabled">
                <div formArrayName="string2jsonRows">
                  <div class="ops-form" *ngFor="let fo of string2jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - String to JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_string2json_obj">

                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_base64decoding_fb" *ngIf="isBase64decodingFromEnabled">
                <div formArrayName="base64decodingRows">
                  <div class="ops-form" *ngFor="let fo of base64decodingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Base64 decoding</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_base64decoding_obj">
                          <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                          <mat-form-field appearance="fill">
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_base64encoding_fb" *ngIf="isBase64encodingFromEnabled">
                <div formArrayName="base64encodingRows">
                  <div class="ops-form" *ngFor="let fo of base64encodingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Base64 encoding</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_base64encoding_obj">
                          <mat-form-field appearance="fill" *ngIf="operation == 'input_type'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>

                          <mat-form-field appearance="fill" *ngIf="operation == 'base64_encode'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_generatesequence_fb" *ngIf="isGeneratesequenceFromEnabled">
                <div formArrayName="generatesequenceRows">
                  <div class="ops-form" *ngFor="let fo of generatesequenceRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Generate Array Sequence Number</label>
                        <div class="ops-form-body"
                          *ngFor="let operation of bizdata_ops_generatesequence_obj;let i=index">

                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_repeatfirstrow_fb" *ngIf="isRepeatfirstrowFromEnabled">
                <div formArrayName="repeatfirstrowRows">
                  <div class="ops-form" *ngFor="let fo of repeatfirstrowRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Repeat First Row Values</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_repeatfirstrow_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_toplevel_fb" *ngIf="isToplevelFromEnabled">
                <div formArrayName="toplevelRows">
                  <div class="ops-form" *ngFor="let fo of toplevelRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Send Keys Top of Root</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_toplevel_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_datetimestamp_fb" *ngIf="isDatetimestampFromEnabled">
                <div formArrayName="datetimestampRows">
                  <div class="ops-form" *ngFor="let fo of datetimestampRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Today Timestamp</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_datetimestamp_obj;let i=index">
                          <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_jsontoxml_fb" *ngIf="isJSON_to_XMLFromEnabled">
                <div formArrayName="jsontoxmlRows">
                  <div class="ops-form" *ngFor="let fo of jsontoxmlRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to XML</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_jsontoxml_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" required />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_xmltojson_fb" *ngIf="isXML_to_JSONFromEnabled">
                <div formArrayName="xmltojsonRows">
                  <div class="ops-form" *ngFor="let fo of xmltojsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - XML TO JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_xmltojson_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_json2dl_fb" *ngIf="isJSON2dlFromEnabled">
                <div formArrayName="json2dlRows">
                  <div class="ops-form" *ngFor="let fo of json2dlRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to delimiter</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json2dl_obj">
                          <mat-form-field appearance="fill" *ngIf="operation != 'fields'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" required />
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="operation == 'fields'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize
                              [formControlName]="operation"></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dl2json_fb" *ngIf="isDl2jsonFromEnabled">
                <div formArrayName="dl2jsonRows">
                  <div class="ops-form" *ngFor="let fo of dl2jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Delimiter to JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dl2json_obj">
                          <mat-form-field appearance="fill" *ngIf="operation != 'fields'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" required />
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="operation == 'fields'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize
                              [formControlName]="operation"></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dl2array_fb" *ngIf="isDl2arrayFormEnabled">
                <div formArrayName="dl2arrayRows">
                  <div class="ops-form" *ngFor="let fo of dl2arrayRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Delimiter to Array</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dl2array_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dataaggregation_fb" *ngIf="isDataaggregationFromEnabled">
                <div formArrayName="dataaggregationRows">
                  <div class="ops-form" *ngFor="let fo of dataaggregationRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data aggregation</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dataaggregation_obj">
                          <mat-form-field appearance="fill" *ngIf="operation == 'agg_data_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation">
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="operation != 'agg_data_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_pivot_fb" *ngIf="isPivotFromEnabled">
                <div formArrayName="pivotRows">
                  <div class="ops-form" *ngFor="let fo of pivotRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Pivot</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_pivot_obj">
                          <mat-form-field appearance="fill" *ngIf="operation == 'get_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation">
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="operation != 'get_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_htmlextractor_fb" *ngIf="isHTMLExtractorFormEnabled">
                <div formArrayName="htmlextractorRows">
                  <div class="ops-form" *ngFor="let fo of htmlextractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - HTML Extractor</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_htmlextractor_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- ********************* -->
              <!-- END of Transformation-->

              <form [formGroup]="bizdata_ops_unpivot_fb" *ngIf="isUnPivotFromEnabled">
                <div formArrayName="unpivotRows">
                  <div class="ops-form" *ngFor="let fo of unpivotRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Unpivot</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_unpivot_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_singleline2tuple_fb" *ngIf="singleline2tupleFormEnabled">
                <div formArrayName="singleline2tupleRows">
                  <div class="ops-form" *ngFor="let fo of singleline2tupleRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Single Line to Tuple</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_singleline2tuple_obj">
                          <mat-form-field appearance="fill" appearance="fill" *ngIf="i == 0 || i == 2">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" required />
                            <!-- <json-editor [formControlName]="operation" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                          <mat-form-field appearance="fill" appearance="fill" *ngIf="i == 1">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                            <!-- <json-editor [formControlName]="operation" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_tuple2singleline_fb" *ngIf="tuple2singlelineFormEnabled">
                <div formArrayName="tuple2singlelineRows">
                  <div class="ops-form" *ngFor="let fo of tuple2singlelineRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Tuple to Single Line</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_tuple2singleline_obj">
                          <mat-form-field appearance="fill" *ngIf="i == 0 || i == 2">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" required />
                            <!-- <json-editor [formControlName]="operation" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="i == 1">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                            <!-- <json-editor [formControlName]="operation" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_singletomultiline_fb" *ngIf="chopFormEnabled">
                <div formArrayName="chopRows">
                  <div class="ops-form" *ngFor="let fo of chopRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Single Line to Multiline</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_singletomultiline_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <!-- <form [formGroup]="bizdata_ops_file_fb" *ngIf="isfileFromEnabled">
                <div formArrayName="fileRows">
                  <div class="ops-form" *ngFor="let fo of fileRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - File</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_file_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form> -->

              <form [formGroup]="bizdata_ops_email_fb" *ngIf="isemailFromEnabled">
                <div formArrayName="emailRows">
                  <div class="ops-form" *ngFor="let fo of emailRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Email</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_email_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input *ngIf="(operation != 'password') && (operation != 'body')" type="text" matInput
                              [formControlName]="operation">
                            <input *ngIf="operation === 'password'" type="password" matInput
                              [formControlName]="operation">
                            <input *ngIf="operation === 'body'" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dlsearch_fb" *ngIf="isDlsearchFormEnabled">
                <div formArrayName="dlsearchRows">
                  <div class="ops-form" *ngFor="let fo of dlsearchRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Bizintel360 DataLake Search</label>
                        <div class="ops-form-body">
                          <mat-card class="m-card data-source">
                            <div class="m-body">
                              <mat-label>Data Lake Version</mat-label>
                              <mat-form-field class="target-businessObj" appearance="fill">
                                <input type="text" matInput formControlName="version">

                              </mat-form-field>
                              <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;">
                                <div>
                                  <p style="margin-top:25px">
                                    <span style="background: #ddd;">bizintel360-</span>
                                  </p>
                                </div>
                                <!-- </div>
                                <div> -->
                                <!-- <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;"> -->
                                <mat-form-field appearance="outline">
                                  <mat-label class="bold-label">Index / Table Name</mat-label>
                                  <input type="text" matInput formControlName="dlsearch_index_name"
                                    (keydown)="bridgenameCheck($event)" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                                <!-- </div> -->
                              </div>
                              <div style="display: grid;grid-template-columns: 50% 50%;grid-column-gap: 2px;">
                                <mat-form-field appearance="outline">
                                  <mat-label class="bold-label">Pagination Wait Time</mat-label>
                                  <input type="text" matInput formControlName="dlsearch_scroll"
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                              <div style="display: grid;grid-template-columns: 50% 50%;grid-column-gap: 2px;">
                                <mat-form-field appearance="outline">
                                  <mat-label class="bold-label">Timeout</mat-label>
                                  <input type="text" matInput formControlName="dlsearch_timeout"
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                              <div style="display: grid;grid-template-columns: 50% 50%;grid-column-gap: 2px;">
                                <mat-form-field appearance="outline">
                                  <mat-label class="bold-label">Size</mat-label>
                                  <input type="text" matInput formControlName="dlsearch_batch_size"
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                              <div class="mat-section" style="padding: 0;">
                                <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                                  <!-- <ngx-monaco-editor formControlName="dlsearch_body" [options]="editorTargetOptions2"
                                                                  (init)="editorInit($event)">
                                                                </ngx-monaco-editor> -->
                                  <ngx-codemirror formControlName="dlsearch_body" #dlSearchEditor
                                    [options]="codeMirrorEditorOptions">
                                  </ngx-codemirror>
                                </div>
                              </div>
                            </div>
                          </mat-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_json_fb" *ngIf="isjsonFormEnabled">
                <div formArrayName="jsonRows">
                  <div class="ops-form" *ngFor="let fo of jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dropeventsstartswith_fb" *ngIf="isdropeventsstartswithFromEnabled">
                <div formArrayName="dropeventsstartswithRows">
                  <div class="ops-form" *ngFor="let fo of dropeventsstartswithRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Drop all events to start with</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dropeventsstartswith_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ")| titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dropalleventvalues_fb" *ngIf="isdropalleventvaluesFromEnabled">
                <div formArrayName="dropalleventvaluesRows">
                  <div class="ops-form" *ngFor="let fo of dropalleventvaluesRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Drop all events for value</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dropalleventvalues_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_eliminate_fb" *ngIf="iseliminateFromEnabled">
                <div formArrayName="eliminateRows">
                  <div class="ops-form" *ngFor="let fo of eliminateRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Eliminate</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_eliminate_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_calculater_fb" *ngIf="iscalculaterFromEnabled">
                <div formArrayName="calculaterRows">
                  <div class="ops-form" *ngFor="let fo of calculaterRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Calculator</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_calculater_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dateanalytics_fb" *ngIf="isdateanalyticsFromEnabled">
                <div formArrayName="dateanalyticsRows">
                  <div class="ops-form" *ngFor="let fo of dateanalyticsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Date Analytics</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dateanalytics_obj; let i=index">
                          <mat-form-field appearance="fill" *ngIf="i == 2">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="i != 2">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation"
                              (keydown)="validateDateAnalytics($event)" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_arraycount_fb" *ngIf="isArraycountFromEnabled">
                <div formArrayName="arraycountRows">
                  <div class="ops-form" *ngFor="let fo of arraycountRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Array Count</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_arraycount_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_pdfextractor_fb" *ngIf="isPdfextractorFormEnabled">
                <div formArrayName="pdfextractorRows">
                  <div class="ops-form" *ngFor="let fo of pdfextractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - PDF Extractor</label>
                        <div class="ops-form-body">
                          <div>
                            <p style="float: left;margin-top: 15px;">PDF Location -</p>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                              [value]="pdfextractorRows().controls[i].value.pdfLocationToggle"
                              (change)="onChangeToggleButton($event,i)">
                              <mat-button-toggle value="file_url"
                                [disabled]="pdfLocationToggleValue === 'base64_key'">File URL Key</mat-button-toggle>
                              <mat-button-toggle value="base64_key"
                                [disabled]="pdfLocationToggleValue === 'file_url'">Base64 Key</mat-button-toggle>
                            </mat-button-toggle-group>
                          </div>
                          <mat-form-field appearance="outline"
                            *ngIf="pdfextractorRows().controls[i].value.pdfLocationToggle == 'file_url'">
                            <mat-label class="bold-label">File URL Key</mat-label>
                            <input matInput cols="100" rows="8" formControlName="file_url" required>
                          </mat-form-field>
                          <mat-form-field appearance="outline"
                            *ngIf="pdfextractorRows().controls[i].value.pdfLocationToggle == 'base64_key'">
                            <mat-label class="bold-label">Base64 Key</mat-label>
                            <input matInput cols="100" rows="8" formControlName="base64_key" required>
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_fileextractor_fb" *ngIf="isFileextractorFormEnabled">
                <div formArrayName="fileextractorRows">
                  <div class="ops-form" *ngFor="let fo of fileextractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - File Extractor</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_fileextractor_obj">
                          <div class="column-operation">
                            <p>
                              Pass key name which is having base64 encoded data of file .
                            </p>
                          </div>
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_grokpattern_fb" *ngIf="isGorkPatternFormEnabled">
                <div formArrayName="grokpatternRows">
                  <div class="ops-form" *ngFor="let fo of grokpatternRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Grok Pattern</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_grokpattern_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_rawsentencegenerator_fb" *ngIf="isRawSentenceGeneratorFormEnabled">
                <div formArrayName="rawsentencegeneratorRows">
                  <div class="ops-form" *ngFor="let fo of rawsentencegeneratorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Raw Sentence Generator</label>
                        <div class="ops-form-body"
                          *ngFor="let operation of bizdata_ops_rawsentencegenerator_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_timeunits_fb" *ngIf="isTimeUnitsFormEnabled">
                <div formArrayName="timeunitsRows">
                  <div class="ops-form" *ngFor="let fo of timeunitsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Time Units</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_timeunits_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_datachunking_fb" *ngIf="isDataChunkingFormEnabled">
                <div formArrayName="datachunkingRows">
                  <div class="ops-form" *ngFor="let fo of datachunkingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data Chunking</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_datachunking_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_json2avro_fb" *ngIf="isJson2avroFormEnabled">
                <div formArrayName="json2avroRows">
                  <div class="ops-form" *ngFor="let fo of json2avroRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to AVRO</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json2avro_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>


              <form [formGroup]="bizdata_ops_avro2json_fb" *ngIf="isAvro2jsonFormEnabled">
                <div formArrayName="avro2jsonRows">
                  <div class="ops-form" *ngFor="let fo of avro2jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - AVRO to JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_avro2json_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_extract2array_fb" *ngIf="isExtract2ArrayFormEnabled">
                <div formArrayName="extract2ArrayRows">
                  <div class="ops-form" *ngFor="let fo of extract2ArrayRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Extract to Array</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_extract2array_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_encodedecode_fb" *ngIf="isEncodedecodeFromEnabled">
                <div formArrayName="encodedecodeRows">
                  <div class="ops-form" *ngFor="let fo of encodedecodeRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Encode Decode</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_encodedecode_obj; let i=index">
                          <mat-form-field appearance="outline" *ngIf="operation != 'process'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                          <mat-label>Select Process</mat-label>
                          <mat-form-field appearance="fill" *ngIf="operation == 'process'">
                            <mat-select formControlName="process" required>
                              <mat-option *ngFor="let obj of processEDOList" [value]="obj.process">
                                {{ obj.process }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_zipfileinbase64_fb" *ngIf="isZipfileinbase64FromEnabled">
                <div formArrayName="zipfileinbase64Rows">
                  <div class="ops-form" *ngFor="let fo of zipfileinbase64Rows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Zipfile in Base64</label>
                        <div class="ops-form-body"
                          *ngFor="let operation of bizdata_ops_zipfileinbase64_obj; let i=index">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_substitute_fb" *ngIf="issubstituteFromEnabled">
                <div formArrayName="substituteRows">
                  <div class="ops-form" *ngFor="let fo of substituteRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Substitute</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_substitute_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_rename_fb" *ngIf="isrenameFromEnabled">
                <div formArrayName="renameRows">
                  <div class="ops-form" *ngFor="let fo of renameRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Rename</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_rename_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea cols="100" rows="8" matInput cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>

                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_strip_fb" *ngIf="isstripFromEnabled">
                <div formArrayName="stripRows">
                  <div class="ops-form" *ngFor="let fo of stripRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Strip</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_strip_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" required />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_substring_fb" *ngIf="issubstringFromEnabled">
                <div formArrayName="substringRows">
                  <div class="ops-form" *ngFor="let fo of substringRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - SubString</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_substring_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_round_fb" *ngIf="isroundFromEnabled">
                <div formArrayName="roundRows">
                  <div class="ops-form" *ngFor="let fo of roundRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Round </label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_round_obj">
                          <mat-form-field appearance="fill" *ngIf="operation != 'decimal_key_number'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="operation == 'decimal_key_number'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation"
                              (keydown)="validateSleetTime($event)" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_sleeptime_fb" *ngIf="issleepFromEnabled">
                <div formArrayName="sleepRows">
                  <div class="ops-form" *ngFor="let fo of sleepRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Sleep Time </label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_sleeptime_obj">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_pycode_fb" *ngIf="ispycodeFromEnabled">
                <div formArrayName="pycodeRows">
                  <div class="ops-form" *ngFor="let fo of pycodeRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Python </label>
                        <div class="ops-form-body">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Pycode</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize formControlName="pycode"
                              required></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Response</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize formControlName="response"
                              required></textarea>
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_aiops_fb" *ngIf="isaiopsFromEnabled">
                <div formArrayName="aiOpsRows">
                  <div class="ops-form" *ngFor="let fo of aiOpsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">AI Operation </label>
                        <div class="ops-form-body">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Question</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize formControlName="question"
                              required></textarea>
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_filter_fb" *ngIf="isfilterFromEnabled">
                <div formArrayName="filterRows">
                  <div class="ops-form" *ngFor="let fo of filterRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Filter </label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_filter_obj">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize [formControlName]="operation"
                              required></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_filterends_fb" *ngIf="isfilterEndsFromEnabled">
                <div formArrayName="filterEndsRows">
                  <div class="ops-form" *ngFor="let fo of filterEndsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Filter Ends </label>
                        <p>This Operations end the filter for a given streaming pipeline</p>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_jdbcoutput_fb" *ngIf="isjdbcoutputFromEnabled">
                <div formArrayName="jdbcoutputRows">
                  <div class="ops-form" *ngFor="let fo of jdbcoutputRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Database | Warehouse | Lakehouse </label>
                        <div class="ops-form-body">
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Storage Name</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="storage_name"
                              required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Version</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="db_version"
                              required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Host IP</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="host_ip" required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Port Number</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="port_number"
                              required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Schema Name</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="schema_name"
                              required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">User Name</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="username" required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Password</mat-label>
                            <input matInput cols="100" type="password" rows="8" cdkTextareaAutosize
                              formControlName="password" required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Order Set of Values (Tuple Key)</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="tuple_key">
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">Batch Size</mat-label>
                            <input matInput cols="100" rows="8" cdkTextareaAutosize formControlName="batch_size"
                              required>
                          </mat-form-field>
                          <mat-form-field appearance="fill">
                            <mat-label class="bold-label">SQL Statement</mat-label>
                            <textarea matInput cols="100" rows="8" cdkTextareaAutosize formControlName="query" required
                              style="color: #bbbbbb;"></textarea>
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_restapi_fb" *ngIf="isrestapiFormEnabled">
                <div formArrayName="restapiRows">
                  <div class="ops-form" *ngFor="let fo of restapiRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - API</label>
                        <div class="ops-form-body-ops">
                          <mat-tab-group class="views-options-data-group-email" fitInkBarToContent
                            mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
                            <mat-tab label="System">
                              <div class="ops-form-body-ops">
                                <mat-card class="m-card data-target">
                                  <ng-template matStepLabel>Data Target</ng-template>
                                  <mat-card class="m-card data-target">
                                    <mat-card-title class="m-title">
                                      <span class="m-header">What is your Data Target?</span>
                                      <span class="sub-content">Please specify or select the Data Target from
                                        Catalog</span>
                                    </mat-card-title>
                                    <div class="m-body">
                                      <mat-form-field class="data-column" appearance="outline" #formFieldTarget>
                                        <mat-label>Search by target name</mat-label>
                                        <input type="text" placeholder="Search by target name"
                                          formControlName="bridge_target" matInput [matAutocomplete]="auto"
                                          (keydown.enter)="$event.preventDefault()" required />
                                        <mat-autocomplete #auto="matAutocomplete">
                                          <mat-option class="create-new" [value]="createNew">Create New</mat-option>
                                          <mat-optgroup *ngFor="let brand of bridgeTarget$ | async"
                                            [label]="brand.brand_name">
                                            <mat-option *ngFor="let product of brand.products" [value]="product">
                                              {{product}}
                                            </mat-option>
                                          </mat-optgroup>
                                        </mat-autocomplete>
                                        <button type="button" mat-button matSuffix aria-label="Search">
                                          <mat-icon>search</mat-icon>
                                        </button>
                                        <button type="button" mat-button
                                          *ngIf="fo.value.bridge_target != '' && fo.value.bridge_target != undefined"
                                          matSuffix aria-label="Clear" >
                                          <mat-icon>clear</mat-icon>
                                        </button>
                                      </mat-form-field>

                                      <div class="column-content">
                                        <mat-icon matSuffix>info</mat-icon>
                                        <p>
                                          Not sure on Data Target? Please checkout the
                                          <a style="text-decoration: none;" target="_blank"
                                            href="#/baseapp/marketplace">Marketplace</a> or
                                          <a style="text-decoration: none;" href="javascript:void(0);">
                                            Add from Cart
                                          </a>
                                        </p>
                                      </div>
                                      <mat-form-field style="margin-top: 15px;" appearance="outline"
                                        *ngIf="fo.value.is_new_target">
                                        <mat-label>Enter Target Name</mat-label>
                                        <input type="text" formControlName="new_bridge_target" matInput
                                          placeholder="Target name" (keydown.enter)="$event.preventDefault()" required>
                                      </mat-form-field>

                                      <mat-form-field appearance="outline" *ngIf="fo.value.is_new_target">
                                        <mat-label>Enter Business Object</mat-label>
                                        <input type="text" formControlName="new_bridge_target_business_object" matInput
                                          placeholder="Business object" (keydown.enter)="$event.preventDefault()"
                                          required>
                                      </mat-form-field>
                                      <mat-form-field class="target-businessObj" appearance="fill">
                                        <mat-label>Select Business Object</mat-label>
                                        <input type="text" matInput formControlName="bridge_target_business_object">
                                      </mat-form-field>
                                    </div>
                                  </mat-card>
                                </mat-card>
                              </div>
                            </mat-tab>
                            <mat-tab label="Test">
                              <mat-card id="rest_api">
                                <div class="views-content-env-ops" >
                                  <div class="views-content-env-data">
                                    <div class="add-environment-button" style="text-align: right;">
                                      <p>{{fo.value.selected_environment}}</p>
                                    </div>
                                    <div class="exit-environment">
                                      <mat-icon class="icon" (click)="showEnvironmentTabRAO=!showEnvironmentTabRAO">
                                        move_down
                                      </mat-icon>
                                    </div>
                                    <div class="env-settings">
                                      <div class="env-settings-wrapper">
                                        <!-- <mat-icon matTooltip="Environment Settings"
                                          matTooltipPosition="above">settings</mat-icon> -->
                                        <mat-select class="env-settings-select"
                                          formControlName="bridge_endpoint_selected_environments_name">
                                          <mat-option value="No Environment">No Environment</mat-option>
                                          <mat-option *ngFor="let tab of selectedEnvTabsRAO" [value]="tab">
                                            {{ tab }}
                                          </mat-option>
                                        </mat-select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="m-body" *ngIf="showEnvironmentTabRAO">
                                  <div class="env-container">
                                    <div class="env-header">
                                      <span class="env-header">Environment Setting</span>
                                    </div>
                                  </div>
                                  <!-- <div class="environment-tab-group"> -->
                                  <div formArrayName="bridge_endpoint_environments_raw">
                                    <div *ngFor="let environments of bridgeRAOEnvironments(i).controls; let j = index">
                                      <div [formGroupName]="j">
                                        <ng-container *ngIf="j === currentDisplayedEnvIndexRAO">
                                          <div class="m-body">
                                            <div class="data-options-grid ng-star-inserted">
                                              <mat-form-field style="margin-top: 15px;" appearance="outline">
                                                <mat-label>Environment Name</mat-label>
                                                <input type="text" formControlName="env_name" matInput
                                                  placeholder="Environment Name"
                                                  (keydown.enter)="$event.preventDefault()" required>
                                              </mat-form-field>
                                            </div>
                                          </div>
                                          <div class="mat-section-restAPI">
                                            <div class="m-body">
                                              <div class="data-options-wrapper">
                                                <div formArrayName="env_vars">
                                                  <div class="data-options-grid"
                                                    *ngFor="let env of env_varsControls(bridgeRAOEnvironments(i).controls[j].get('env_vars')).controls; let envIndex = index">
                                                    <ng-container [formGroupName]="envIndex">
                                                      <mat-form-field style="margin-top: 15px;" appearance="outline">
                                                        <mat-label>Variable</mat-label>
                                                        <input type="text" placeholder="Variable" matInput
                                                          formControlName="variable" required >
                                                      </mat-form-field>
                                                      <mat-form-field class="mat-dropdown" appearance="outline">
                                                        <mat-label>Type</mat-label>
                                                        <!-- <mat-select placeholder="Type" formControlName="type">
                                                          <mat-option *ngFor="let type of environmentType"
                                                            [value]="type.value">{{
                                                            type.viewValue }}</mat-option>
                                                        </mat-select> -->
                                                        <input matInput formControlName="type" >
                                                      </mat-form-field>
                                                      <mat-form-field appearance="outline">
                                                        <mat-label>Value</mat-label>
                                                        <input [type]="env.value.valueType"
                                                          [id]="'environmentValue-' + envIndex" placeholder="Value"
                                                          matInput formControlName="value">
                                                        <mat-icon *ngIf="env.value.type === 'password'" matSuffix>
                                                          {{ env.value.valueType == 'password' ?
                                                          'visibility_off' : 'visibility'
                                                          }}
                                                        </mat-icon>
                                                      </mat-form-field>
                                                    </ng-container>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- </div> -->
                                </div>
                                <div class="m-body" *ngIf="!showEnvironmentTabRAO">
                                  <div class="views-content-data-restApi">
                                    <div class="data-options">
                                      <mat-form-field class="data-options-dropdown" appearance="outline">
                                        <input matInput formControlName="endpoint_method">
                                      </mat-form-field>
                                    </div>
                                    <div class="data-url">
                                      <mat-form-field class="data-url" appearance="outline">
                                        <textarea rows="1" matInput placeholder="Request URL" class="contentDiv" id="contentDivOps{{i}}" 
                                          formControlName="endpoint_url"
                                          (keydown.enter)="$event.preventDefault()" id="rest_api_url{{i}}"></textarea>
                                      </mat-form-field>
                                    </div>
                                    <div class="data-btn" *ngIf="spinnerTargetRAOShow == false">
                                      <button mat-raised-button type="button" class="btn-test" [disabled]="isDisabled">Test</button>
                                    </div>
                                  </div>
                                  <mat-tab-group animationDuration="0ms"
                                    class="views-options-data-group-postman-restapi"
                                    (selectedTabChange)="postmanTabChangeROA($event,fo.value.id,i)">
                                    <mat-tab label="Params">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body">
                                          <div class="data-options-wrapper">
                                            <div formArrayName="bridge_target_endpoint_params_raw">
                                              <div class="data-options-grid-ops"
                                                *ngFor="let params of bridgeTargetParamsRAO(i).controls;let j = index">
                                                <ng-container [formGroupName]="j">
                                                  <mat-form-field appearance="outline">
                                                    <input type="text" formControlName="endpoint_params_key" matInput
                                                      placeholder="Key" (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>

                                                  <mat-form-field appearance="outline">
                                                    <input type="text" formControlName="endpoint_params_value"
                                                      matInput placeholder="Value"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <mat-form-field appearance="outline">
                                                    <input type="text" formControlName="endpoint_params_description"
                                                      matInput placeholder="Description"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <!-- <div class="btn-view">
                                                    <mat-icon class="icon">
                                                      add
                                                    </mat-icon>
                                                  </div>
                                                  <div class="btn-view">
                                                    <mat-icon class="icon">
                                                      remove
                                                    </mat-icon>
                                                  </div> -->
                                                </ng-container>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Authorization">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body">
                                          <div class="authentication-view">
                                            <div class="view-options-drop">
                                              <mat-label>Select Type</mat-label>

                                              <mat-form-field class="mat-dropdown" appearance="outline">
                                                <input matInput formControlName="authentication_type">
                                              </mat-form-field>
                                            </div>

                                            <div class="view-body">
                                              <ng-container
                                                *ngIf="fo.value.authentication_type_id.value == 3">
                                                <div class="view-options">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>Token</mat-label>
                                                    <input type="text" matInput placeholder="Token"
                                                      formControlName="bridge_target_authentication_token"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                </div>
                                              </ng-container>

                                              <ng-container
                                                *ngIf="fo.value.authentication_type_id.value == 4">
                                                <div class="view-options">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>Username</mat-label>
                                                    <input [type]="'password'" matInput placeholder="Username"
                                                      formControlName="username"
                                                      (keydown.enter)="$event.preventDefault()">
                                                    <!-- <mat-icon matSuffix>visibility_off</mat-icon> -->
                                                  </mat-form-field>
                                                  <!-- <mat-label>Username *</mat-label>
                                                  <div class="contAiner">
                                                    <div id="contentDevOpsAuthUser{{i}}" class="contentDevOpsAuth"
                                                      placeholder="Username" contenteditable="true">{{ops_authUser[i]}}</div>
                                                    <mat-icon class="buttOn" matSuffix>visibility_off</mat-icon>
                                                  </div> -->
                                                </div>
                                                <div class="view-options">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>Password</mat-label>
                                                    <input [type]="'password'" matInput placeholder="Password"
                                                      formControlName="password"
                                                      (keydown.enter)="$event.preventDefault()">
                                                    <!-- <mat-icon matSuffix></mat-icon> -->
                                                  </mat-form-field>
                                                  <!-- <mat-label>Password *</mat-label> -->
                                                  <!-- <div class="contAiner">
                                                    <div id="contentDevOpsAuthPassword{{i}}" class="contentDevOpsAuth"
                                                      placeholder="Password" contenteditable="true">
                                                      {{ops_authPassword[i]}}</div>
                                                    <mat-icon class="buttOn" matSuffix>visibility_off</mat-icon>
                                                  </div> -->
                                                </div>
                                              </ng-container>
                                              <ng-container
                                                *ngIf="fo.value.authentication_type_id.value == 6">
                                                <div class="view-options-drop">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>Refresh Token Endpoint Method</mat-label>
                                                    <input matInput
                                                      formControlName="refresh_token_method">
                                                  </mat-form-field>
                                                </div>
                                                <div class="view-options">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>Refresh Token Endpoint URL</mat-label>
                                                    <input type="text" matInput placeholder="Refresh Token Endpoint URL"
                                                      formControlName="refresh_token_url"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  
                                                  <div class="view-options-auth">
                                                    <mat-label>Refresh Token Endpoint Header</mat-label>
                                                    <mat-form-field>
                                                      <textarea matInput class="codemirror-color"
                                                        formControlName="refresh_token_headers">
                                                      </textarea>
                                                    </mat-form-field>
                                                  </div>
                                                  <div class="view-options-auth">
                                                    <mat-label>Refresh Token Endpoint params</mat-label>
                                                    <mat-form-field>
                                                      <textarea matInput class="codemirror-color"
                                                        formControlName="refresh_token_params">
                                                      </textarea>
                                                    </mat-form-field>
                                                  </div>
                                                  <div class="view-options-auth">
                                                    <mat-label>Refresh Token Endpoint params</mat-label>
                                                    <mat-form-field>
                                                      <textarea matInput class="codemirror-color"
                                                        formControlName="refresh_token_body">
                                                      </textarea>
                                                    </mat-form-field>
                                                  </div>
                                                </div>
                                              </ng-container>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Headers">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body">
                                          <div class="data-options-wrapper">
                                            <div formArrayName="bridge_target_endpoint_headers">
                                              <div class="data-options-grid-ops"
                                                *ngFor="let headers of bridgeTargetHeadersRAO(i).controls;let j = index">
                                                <ng-container [formGroupName]="j">
                                                  <mat-form-field appearance="outline">
                                                    <input type="text" placeholder="Key"
                                                      formControlName="endpoint_headers_key" matInput
                                                      placeholder="Key" (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>

                                                  <mat-form-field appearance="outline">
                                                    <input type="text" placeholder="Key" matInput
                                                      formControlName="endpoint_headers_value"
                                                      (keydown.enter)="$event.preventDefault()"
                                                      id="ib_update_target_endpoint_header_key{{i}}">
                                                  </mat-form-field>

                                                  <mat-form-field appearance="outline">
                                                    <input type="text" formControlName="endpoint_headers_description"
                                                      matInput placeholder="Value"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                </ng-container>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Body">
                                      <div class="mat-section-restAPI">
                                        <div style="width: 25%;">
                                            <mat-label>Select Type</mat-label>

                                          <mat-form-field class="mat-dropdown" appearance="outline">
                                            <!-- <mat-select formControlName="bridge_target_body_type">
                                              <mat-option *ngFor="let type of bodyTypeOptions" [value]="type.type">
                                                {{ type.type }}
                                              </mat-option>
                                            </mat-select> -->
                                            <input matInput formControlName="bridge_target_body_type">
                                          </mat-form-field>
                                        </div>
                                        <div class="m-body">
                                          <!-- <ngx-codemirror formControlName="endpoint_body"
                                            #bodyRestAPIEditor [options]="codeMirrorEditorOptions">
                                          </ngx-codemirror> -->
                                          <mat-form-field appearence="outline">
                                            <textarea matInput type="text" matInput formControlName="endpoint_body"></textarea>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Pre-request Script">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body-script">
                                          <ngx-codemirror class="codemirror-color" formControlName="pre_request_script"
                                            #preRequestScriptEditorROA [options]="preRequestScriptEditorOptions">
                                          </ngx-codemirror>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <!-- <mat-tab label="Environment Variable">
                                      <mat-tab-group [selectedIndex]="selectedTargetTabIndexRAO">
                                        <mat-tab *ngFor="let tab of targetRAOTabs; let tabIndex = index">
                                          <ng-template mat-tab-label>
                                            {{ tab }}
                                            <div class="env-cancel-button">
                                              <mat-icon class="icon">
                                                cancel
                                              </mat-icon>
                                            </div>
                                          </ng-template>
                                          <form [formGroup]="environmentTargetRAOForm">
                                            <div formArrayName="bridge_targetRAO_endpoint_environments_raw"
                                              style="margin-top: 20px;">
                                              <div
                                                *ngFor="let environments of bridgeTargetEnvironments().controls; let i = index">
                                                <div [formGroupName]="i">
                                                  <div class="environment-variable-container">
                                                    <div class="environment-variable-tabs">
                                                      <div formArrayName="env_vars">
                                                        <ng-container *ngIf="environments.value.env_name == tab">
                                                          <div
                                                            *ngFor="let env of envTargetData(i).controls; let envIndex = index">
                                                            <div [formGroupName]="envIndex">
                                                              <div class="data-options-wrapper-environment">
                                                                <div class="environment-variable-input">
                                                                  <mat-form-field appearance="outline">
                                                                    <input type="text" placeholder="Variable" matInput
                                                                      formControlName="variable" (keydown.enter)="$event.preventDefault()">
                                                                  </mat-form-field>
                                                                </div>
                                                                <div class="environment-variable-input">
                                                                  <mat-form-field class="mat-dropdown"
                                                                    appearance="outline">
                                                                    <mat-select placeholder="Type"
                                                                      formControlName="type"
                                                                      (selectionChange)="envTargetChangeType($event,envIndex,i)">
                                                                      <mat-option *ngFor="let type of environmentType"
                                                                        [value]="type.value">
                                                                        {{ type.viewValue }}</mat-option>
                                                                    </mat-select>
                                                                  </mat-form-field>
                                                                </div>
                                                                <div class="environment-variable-input">
                                                                  <mat-form-field appearance="outline">
                                                                    <input [type]="env.value.valueType"
                                                                      [id]="'environmentValue-' + i" placeholder="Value"
                                                                      matInput formControlName="value">
                                                                    <mat-icon *ngIf="env.value.type === 'password'"
                                                                      matSuffix
                                                                      (click)="toggleTargetPassword(i, envIndex)">
                                                                      {{ env.value.valueType == 'password' ?
                                                                      'visibility_off' : 'visibility' }}
                                                                    </mat-icon>
                                                                  </mat-form-field>
                                                                </div>
                                                                <div class="btn-view">
                                                                  <mat-icon class="icon"
                                                                    (click)="addTargetEnvironmentsTabRAO(i)">
                                                                    add
                                                                  </mat-icon>
                                                                </div>
                                                                <div class="btn-view">
                                                                  <mat-icon class="icon"
                                                                    (click)="removeTargetEnvironmentsTabRAO(i, envIndex)">
                                                                    remove
                                                                  </mat-icon>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </ng-container>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </form>
                                        </mat-tab>
                                      </mat-tab-group>
                                    </mat-tab> -->
                                  </mat-tab-group>
                                  <div class="res-container">
                                    <div class="res-header">
                                      <h3 style="margin:0">Response Params</h3>
                                      <span class="res-header">
                                        <!-- <mat-radio-group formControlName="response_type">
                                          <mat-radio-button value="text">Text</mat-radio-button>
                                          <mat-radio-button value="content">Content</mat-radio-button>
                                          <mat-radio-button value="json">JSON</mat-radio-button>
                                        </mat-radio-group> -->
                                        <mat-form-field appearence="outline">
                                          <input matInput formControlName="response_type">
                                        </mat-form-field>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </mat-card>
                            </mat-tab>
                          </mat-tab-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dlakeingestion_fb" *ngIf="isDLIngestionFormEnabled">
                <div formArrayName="dlIngestionRows">
                  <div class="ops-form" *ngFor="let fo of dlIngestionRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Bizintel360 DataLake Ingestion</label>
                        <div class="ops-form-body">
                          <mat-card class="m-card data-source">
                            <div class="m-body">
                              <mat-label>Data Lake Version</mat-label>
                              <mat-form-field class="target-businessObj" appearance="fill">
                                <mat-select formControlName="version"
                                  (selectionChange)="onChangeGetDlversion($event,i)">
                                  <mat-option *ngIf="verisonListDLO.length == 0">
                                    No record found
                                  </mat-option>
                                  <mat-option *ngFor="let version of verisonListDLO" [value]="version">
                                    {{ version.dlversion }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;">
                                <div>
                                  <p style="margin-top:25px">
                                    <span style="background: #ddd;">bizintel360-</span>
                                  </p>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline">
                                    <mat-label class="bold-label">Index / Table Name</mat-label>
                                    <input type="text" matInput formControlName="index_name"
                                      (keydown)="bridgenameCheck($event)" required>
                                  </mat-form-field>
                                </div>
                              </div>
                              <mat-label>Action Type</mat-label>
                              <mat-form-field class="target-businessObj" appearance="fill">
                                <mat-select formControlName="action_type">
                                  <mat-option *ngFor="let type of actionTypeListDLO" [value]="type.actionTypevalue">
                                    {{ type.actionTypeTitle }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <mat-form-field appearance="outline"
                                *ngIf="fo.value.action_type == 'upsert' || fo.value.action_type == 'update' || fo.value.action_type == 'delete'">
                                <mat-label class="bold-label">Primary Key</mat-label>
                                <input type="text" matInput formControlName="primary_key">
                              </mat-form-field>
                              <mat-label>Ingestion Type</mat-label>
                              <mat-form-field class="target-businessObj" appearance="fill">
                                <mat-select formControlName="indexing_type">
                                  <mat-option *ngFor="let type of indexingTypeListDLO" [value]="type.indexTypevalue">
                                    {{ type.indexTypeTitle }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </mat-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_docunderstanding_fb" *ngIf="isDocunderstandingFromEnabled">
                <div formArrayName="docunderstandingRows">
                  <div class="ops-form" *ngFor="let fo of docunderstandingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Document Understanding </label>
                        <div class="ops-form-body">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">Processing Text</mat-label>
                            <input type="text" matInput formControlName="text_key" placeholder="['processed_text']"
                              required>
                          </mat-form-field>
                          <div class="views-options-data-group">
                            <div class="mat-section-restAPI">
                              <div class="m-body">
                                <div class="data-options-wrapper">
                                  <div formArrayName="questions" class="data-options-grid-question"
                                    *ngFor="let params of docunderstandingOperationRow(i).controls;let j = index">
                                    <!-- <div > -->
                                    <ng-container [formGroupName]="j">
                                      <mat-form-field appearance="outline">
                                        <input type="text" matInput formControlName="docunderstanding_question"
                                          placeholder="Question?" aria-disabled="true">
                                      </mat-form-field>

                                      <mat-form-field appearance="outline">
                                        <input type="text" matInput formControlName="docunderstanding_attribute"
                                          placeholder="Attribute?" aria-disabled="true">
                                      </mat-form-field>

                                      <!-- <div class="btn-view">
                                      <mat-icon class="icon" (click)="addDocunderstandingQuestion(i)">
                                        add
                                      </mat-icon>
                                    </div>
                                    <div class="btn-view">
                                      <mat-icon class="icon" (click)="removeDocunderstandingQuestion(i,j)">
                                        remove
                                      </mat-icon>
                                    </div> -->
                                    </ng-container>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">Understanding Key</mat-label>
                            <input type="text" matInput formControlName="output_key" required>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_imgunderstanding_fb" *ngIf="isImgunderstandingFromEnabled">
                <div formArrayName="imgunderstandingRows">
                  <div class="ops-form" *ngFor="let fo of imgunderstandingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Image Understanding </label>
                        <div class="ops-form-body" style="width:100%">
                          <!-- <p>Key Name which holds the complete image data.For Example:
                            <span  style="background-color: #ddd;" >['image_0']</span>  -->
                          <!-- Refer 
                            <a style="text-decoration: none; font-style: italic;" target="_blank"
                            href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-parameter-%3A-processi-0">
                           here</a> -->
                          <!-- </p> -->
                          <mat-form-field appearance="outline" style="width:600px" class="input-suffix">
                            <mat-label class="bold-label">Processing Image</mat-label>
                            <input type="text" matInput formControlName="img_key" placeholder="['processed_text']"
                              id="copy1_{{i}}_img_key" required>
                          </mat-form-field>
                          <div class="views-options-data-group">
                            <div class="mat-section-restAPI">
                              <div class="m-body">
                                <div class="data-options-wrapper">
                                  <div formArrayName="questions" class="data-options-grid-question"
                                    *ngFor="let params of imgunderstandingOperationRow(i).controls;let j = index">
                                    <!-- <div > -->
                                    <ng-container [formGroupName]="j">
                                      <div>
                                        <!-- <p>Ask questions to your Data. For Example
                                          <span  style="background-color: #ddd;" >What is the name of State?</span> -->
                                        <!-- Refer 
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                          href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-parameter-%3A-processi-0">
                                          here </a> -->
                                        <!-- </p> -->
                                        <mat-form-field appearance="outline">
                                          <input type="text" matInput formControlName="imgunderstanding_question"
                                            placeholder="Question?" aria-disabled="true">
                                        </mat-form-field>
                                      </div>

                                      <div class="image_attribute">
                                        <mat-form-field appearance="outline">
                                          <input type="text" matInput formControlName="imgunderstanding_attribute"
                                            placeholder="Attribute?" aria-disabled="true">
                                        </mat-form-field>
                                      </div>

                                      <!-- <div class="btn-view" style=" position: relative;
                                      top: 51px;
                                      right: 160px;">
                                        <mat-icon class="icon" (click)="addImgunderstandingQuestion(i)">
                                          add
                                        </mat-icon>
                                      </div>
                                      <div class="btn-view" style=" position: relative;
                                      top: 51px;
                                      right: 160px;">
                                        <mat-icon class="icon" (click)="removeImgunderstandingQuestion(i,j)">
                                          remove
                                        </mat-icon>
                                      </div> -->
                                    </ng-container>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="img-understanding">
                              <!-- <p>Key Name which holds the understanding data. For Example:
                                <span style="background-color: #ddd;">Answers</span>  -->
                              <!-- Refer 
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                              href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-parameter-%3A-processi-0">
                            here</a> -->
                              <!-- </p> -->
                              <mat-form-field appearance="outline" style="width:600px">
                                <mat-label class="bold-label">Understanding Key</mat-label>
                                <input type="text" matInput formControlName="output_key" required placeholder="understanding
                                ">
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <!-- <form [formGroup]="bizdata_ops_restapi_fb" *ngIf="isrestapiFormEnabled">
                <div formArrayName="restapiRows">
                  <div class="ops-form" *ngFor="let fo of restapiRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - API</label>
                        <div class="ops-form-body-ops" >
                          <mat-tab-group class="views-options-data-group-email" fitInkBarToContent
                            mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
                            <mat-tab label="System" [disabled]="isDisabled">
                              <div class="ops-form-body-ops">
                                <mat-card class="m-card data-target">
                                  <ng-template matStepLabel>Data Target</ng-template>
                                  <mat-card class="m-card data-target">
                                    <mat-card-title class="m-title">
                                      <span class="m-header">What is your Data Target?</span>
                                      <span class="sub-content">Please specify or select the Data Target from
                                        Catalog</span>
                                    </mat-card-title>
                                    <div class="m-body">
                                      <mat-form-field class="data-column" appearance="outline" #formFieldTarget>
                                        <mat-label>Search by target name</mat-label>
                                        <input type="text" placeholder="Search by target name"
                                          formControlName="bridge_target" matInput [matAutocomplete]="auto"
                                          (keydown.enter)="$event.preventDefault()" required />
                                        <mat-autocomplete #auto="matAutocomplete">
                                          <mat-option class="create-new" [value]="createNew">Create New</mat-option>
                                          <mat-optgroup *ngFor="let brand of bridgeTarget$ | async"
                                            [label]="brand.brand_name">
                                            <mat-option *ngFor="let product of brand.products" [value]="product">
                                              {{product}}
                                            </mat-option>
                                          </mat-optgroup>
                                        </mat-autocomplete>
                                        <button type="button" mat-button matSuffix aria-label="Search">
                                          <mat-icon>search</mat-icon>
                                        </button>
                                        <button type="button" mat-button
                                          *ngIf="fo.value.bridge_target != '' && fo.value.bridge_target != undefined"
                                          matSuffix aria-label="Clear" >
                                          <mat-icon>clear</mat-icon>
                                        </button>
                                      </mat-form-field>

                                      <div class="column-content">
                                        <mat-icon matSuffix>info</mat-icon>
                                        <p>
                                          Not sure on Data Target? Please checkout the
                                          <a style="text-decoration: none;" target="_blank"
                                            href="#/baseapp/marketplace">Marketplace</a> or
                                          <a style="text-decoration: none;" href="javascript:void(0);">
                                            Add from Cart
                                          </a>
                                        </p>
                                      </div>
                                      <mat-form-field style="margin-top: 15px;" appearance="outline"
                                        *ngIf="fo.value.is_new_target">
                                        <mat-label>Enter Target Name</mat-label>
                                        <input type="text" formControlName="new_bridge_target" matInput
                                          placeholder="Target name" (keydown.enter)="$event.preventDefault()" required>
                                      </mat-form-field>

                                      <mat-form-field appearance="outline" *ngIf="fo.value.is_new_target">
                                        <mat-label>Enter Business Object</mat-label>
                                        <input type="text" formControlName="new_bridge_target_business_object" matInput
                                          placeholder="Business object" (keydown.enter)="$event.preventDefault()"
                                          required>
                                      </mat-form-field>
                                      <mat-form-field class="target-businessObj" appearance="fill">
                                        <mat-label>Select Business Object</mat-label>
                                        <input type="text" matInput formControlName="bridge_target_business_object">
                                      </mat-form-field>
                                    </div>
                                  </mat-card>
                                </mat-card>
                              </div>
                            </mat-tab>
                            <mat-tab label="Test" [disabled]="isDisabled">
                              <mat-card id="rest_api">
                                <div class="views-content-env-ops">
                                  <div class="views-content-env-data">
                                  </div>
                                </div>
                              </mat-card>
                            </mat-tab>
                          </mat-tab-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form> -->

            </mat-card-content>
          </mat-card>
          <div class="action-btn-section">
            <button mat-stroked-button matStepperPrevious class="previous">
              <mat-icon matSuffix>west</mat-icon>Previous
            </button>
            <button mat-stroked-button matStepperNext class="next">
              Next<mat-icon matSuffix>east</mat-icon>
            </button>
            <button mat-stroked-button matStepperPrevious routerLink="/baseapp/integration" class="previous">
              <mat-icon matSuffix>west</mat-icon>Go Back
            </button>
          </div>
        </mat-step>

        <mat-step [stepControl]="dataTarget" [completed]="false">
          <form [formGroup]="dataTarget">
            <ng-template matStepLabel>Data Target</ng-template>
            <mat-card class="m-card source">
              <mat-card-title class="m-title">
                <span class="m-header">Data Target Type</span>
              </mat-card-title>
              <div class="m-body">
                <mat-label>Target Type</mat-label>
                <mat-form-field class="data-column" appearance="fill">
                  <input type="text" matInput id="ib_details_target_type" formControlName="bridge_target_type">
                </mat-form-field>
              </div>
            </mat-card>
            <mat-card class="m-card data-target" *ngIf="bridge_target_type == 1">
              <mat-card-title class="m-title">
                <span class="m-header">Data Target Information</span>
              </mat-card-title>
              <div class="m-body">
                <mat-label>Data Target</mat-label>
                <mat-form-field class="data-column" appearance="fill">
                  <input type="text" matInput formControlName="bridge_target" id="ib_details_target_target_name">
                </mat-form-field>

                <mat-label *ngIf="isNewTarget">Enter Target Name</mat-label>
                <mat-form-field style="margin-top: 15px;" appearance="fill" *ngIf="isNewTarget">
                  <input type="text" formControlName="new_bridge_target" id="ib_details_target_enter_target_name"
                    matInput placeholder="Target name" required>
                </mat-form-field>

                <mat-label *ngIf="isNewTarget">Enter Business Object</mat-label>
                <mat-form-field appearance="fill" *ngIf="isNewTarget">
                  <input type="text" formControlName="new_bridge_target_business_object"
                    id="ib_details_target_businessObj" matInput placeholder="Business object" required>
                </mat-form-field>
                <mat-label *ngIf="!isNewTarget">Business Object</mat-label>
                <mat-form-field class="target-businessObj" appearance="fill" *ngIf="!isNewTarget">
                  <input type="text" matInput formControlName="bridge_target_business_object"
                    id="ib_details_target_enter_businessObj">
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card class="m-card data-source-postman" *ngIf="bridge_target_type == 1">
              <div class="m-body">
                <div class="views-content-data">
                  <div class="data-options-view">
                    <mat-form-field class="data-options-dropdown-view" appearance="fill">
                      <input type="text" matInput formControlName="bridge_target_endpoint_method"
                        id="ib_details_target_endpoint_method">
                    </mat-form-field>
                  </div>
                  <div class="data-url-view">
                    <mat-form-field class="data-url-view" appearance="fill">
                      <textarea rows="1" class="input-url-view" matInput id="ib_details_target_endpoint_request_url"
                        formControlName="bridge_target_endpoint_url"></textarea>
                    </mat-form-field>
                  </div>
                </div>

                <mat-tab-group animationDuration="0ms" class="views-options-data-group"
                  (selectedTabChange)="targetPostmanTabChange($event)">
                  <mat-tab label="Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_target_endpoint_params_raw"
                            *ngFor="let params of bridgeTargetParams?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_target_paramKey" matInput placeholder="Key"
                                  id="ib_details_target_endpoint_params_key" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_target_paramValue" matInput
                                  id="ib_details_target_endpoint_params_value" placeholder="Value" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_target_paramDescription" matInput
                                  id="ib_details_target_endpoint_params_desc" placeholder="Description"
                                  [readonly]="true">
                              </mat-form-field>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Authorization">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="authentication-view">
                          <div class="view-options-drop">
                            <mat-label>OAuth Type</mat-label>

                            <mat-form-field class="mat-dropdown" appearance="fill">
                              <input type="text" matInput formControlName="bridge_target_endpoint_authentication_type"
                                id="ib_details_target_endpoint_authentication_type">
                            </mat-form-field>
                          </div>

                          <div class="view-body">
                            <ng-container *ngIf="selectTargetType == 3">
                              <div class="view-options">
                                <mat-label>Token</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Token"
                                    id="ib_details_target_endpoint_authentication_token"
                                    formControlName="bridge_target_authentication_token">
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectTargetType == 4">
                              <div class="view-options">
                                <mat-label>Username</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Username"
                                    [type]="isHidden ? 'password' : 'text'"
                                    id="ib_details_target_endpoint_authentication_username"
                                    formControlName="bridge_target_authentication_username">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Password</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Password"
                                    [type]="isHidden ? 'password' : 'text'"
                                    id="ib_details_target_endpoint_authentication_password"
                                    formControlName="bridge_target_authentication_password">
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectTargetType == 6">
                              <div class="view-options-drop">
                                <mat-label>Refresh Token Method</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token Method"
                                    id="ib_details_target_endpoint_authentication_method"
                                    formControlName="bridge_target_oauth_refresh_token_endpoint_method">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token URL</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token URL"
                                    id="ib_details_target_endpoint_authentication_url"
                                    formControlName="bridge_target_oauth_refresh_token_endpoint_url">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token Header</mat-label>
                                <mat-form-field appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token Header"
                                    id="ib_details_target_endpoint_authentication_header"
                                    formControlName="bridge_target_oauth_refresh_token_endpoint_header">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token Params</mat-label>
                                <mat-form-field style="width: 100%;" appearance="fill">
                                  <input type="text" matInput placeholder="Refresh Token Params"
                                    id="ib_details_target_endpoint_authentication_param"
                                    formControlName="bridge_target_oauth_refresh_token_endpoint_params">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-label>Refresh Token Body</mat-label>
                                <mat-form-field style="width: 100%;" appearance="fill">
                                  <textarea matInput cdkTextareaAutosize rows="5" placeholder="Refresh Token Body"
                                    id="ib_details_target_endpoint_authentication_body"
                                    formControlName="bridge_target_oauth_refresh_token_endpoint_body"></textarea>
                                </mat-form-field>
                              </div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Headers">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_target_endpoint_headers"
                            *ngFor="let headers of bridgeTargetHeaders?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_target_headerKey" matInput placeholder="Key"
                                  id="ib_details_target_endpoint_header_key" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_target_headerValue" matInput
                                  id="ib_details_target_endpoint_header_value" placeholder="Value" [readonly]="true">
                              </mat-form-field>

                              <mat-form-field appearance="fill">
                                <input type="text" formControlName="bridge_target_headerDescription" matInput
                                  id="ib_details_target_endpoint_header_desc" placeholder="Description"
                                  [readonly]="true">
                              </mat-form-field>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Body" *ngIf="targetbodyFlag">
                    <div class="mat-section">
                      <div style="width: 25%;">
                        <mat-label>Select Type</mat-label>
                        <mat-form-field class="mat-dropdown" appearance="outline">
                          <mat-select formControlName="bridge_target_body_type"
                            id="ib_details_target_endpoint_body_type">
                            <mat-option *ngFor="let type of bodyTypeOptions" [value]="type.type">
                              {{ type.type }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="m-body-script">
                        <ngx-codemirror formControlName="bridge_target_endpoint_body_raw"
                          id="ib_details_target_endpoint_header_raw" #bodyTargetEditor
                          [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Pre-request Script">
                    <div class="mat-section">
                      <div class="m-body-script">
                        <!-- <ngx-monaco-editor formControlName="pre_request_script" [options]="editorTargetOptions2"
                          (init)="editorInit($event)">
                        </ngx-monaco-editor> -->
                        <ngx-codemirror formControlName="pre_request_script"
                          id="ib_details_target_endpoint_pre_request_script" #targetPreRequestScriptEditor
                          [options]="preRequestScriptEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_target_type == 2">
              <div class="ops-form-body" *ngIf="isjdbcTargetFromEnabled">

                <mat-card class="m-card data-source">
                  <div class="m-body">

                    <div class="data-btn">
                      <label class="ops-lab-data-target">Storage Details</label>
                      <!-- <button mat-raised-button type="button" class="btn-test"
                        (click)="testDataTargetJdbc()">Execute</button> -->
                    </div>
                    <mat-label>Select Storage Name</mat-label>
                    <mat-form-field appearance="fill">
                      <!-- <mat-select formControlName="storage_name"
                        (selectionChange)="onChangeDataTargetStorageNameJDBCO($event)" required>
                        <mat-option *ngFor="let obj of storageNameJDBCOList" [value]="obj">
                          {{ obj.storage_name }}
                        </mat-option>
                      </mat-select> -->
                      <input matInput type="text" formControlName="storage_name" id="ib_details_target_storage_name"
                        readonly>
                    </mat-form-field>
                    <mat-label>Select Version</mat-label>
                    <mat-form-field appearance="fill">
                      <input matInput type="text" formControlName="db_version" id="ib_details_target_dbVersion"
                        readonly>
                    </mat-form-field>
                    <mat-label>Host IP</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="host_ip" matInput placeholder="Host IP"
                        id="ib_details_target_host" readonly>
                    </mat-form-field>
                    <mat-label>Port Number</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="port_number" matInput id="ib_details_target_port" readonly>
                    </mat-form-field>
                    <mat-label>Schema Name</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="schema_name" matInput id="ib_details_target_schema" readonly>
                    </mat-form-field>
                    <mat-label>User Name</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="username" matInput id="ib_details_target_username" readonly>
                    </mat-form-field>
                    <mat-label>Password</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="password" formControlName="password" matInput id="ib_details_target_password"
                        readonly>
                    </mat-form-field>
                    <mat-label>Order Set of Values (Tuple Key)</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="tuple_key" matInput id="ib_details_target_tuple" readonly>
                    </mat-form-field>
                    <mat-label>Batch Size</mat-label>
                    <mat-form-field appearance="fill">
                      <input type="text" formControlName="batch_size" matInput id="ib_details_target_batch" readonly>
                    </mat-form-field>
                    <mat-card class="mat-section detail" style="border:1px groove;border-radius: 5px;">
                      <p style="margin-left: 10px;color: #bdbdbd !important;">SQL Statement</p>
                      <div class="m-body-script">
                        <!-- <ngx-monaco-editor formControlName="query" [options]="editorPycodeOption"
                          (init)="pycodeResponseeditorInit($event)">
                        </ngx-monaco-editor> -->
                        <!-- <textarea matInput cols="100" rows="8" cdkTextareaAutosize  id="ib_details_target_db_query" formControlName="query" style="color: #bbbbbb;"></textarea> -->
                        <ngx-codemirror formControlName="query" #queryEditor id="ib_details_target_query"
                          [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </mat-card>
                    <div class="res-container">
                      <div class="res-header">
                        <span class="res-header">Response</span>
                        <span *ngIf="data_target_status">
                          <span class="res-status" *ngIf="data_target_status">Status:
                            <strong>{{data_target_status}}</strong></span>
                        </span>
                      </div>
                    </div>
                    <mat-card class="mat-section" style="border:1px groove;border-radius: 5px;">
                      <div class="m-body-script">
                        <!-- <ngx-monaco-editor formControlName="response" [options]="editorPycodeOption"
                          (init)="jdbcResponseeditorInit($event)">
                        </ngx-monaco-editor> -->
                        <!-- <textarea matInput cols="100" rows="8" cdkTextareaAutosize formControlName="response" id="ib_details_target_db_response" style="color: #bbbbbb;"></textarea> -->
                        <ngx-codemirror formControlName="response" id="ib_details_target_db_response"
                          #queryresponseEditor [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </mat-card>
                  </div>
                </mat-card>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_target_type == 3">
              <div class="ops-form-body">
                <mat-card class="m-card data-source">
                  <div class="m-body">
                    <mat-label>Data Lake Version</mat-label>
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <input matInput formControlName="version" type="text" id="ib_details_target_dlVersion" readonly>
                      <!-- <mat-select formControlName="version" (selectionChange)="onChangeDTGetDlversion($event)" required>
                          <mat-option *ngFor="let version of verisonListDLO" [value]="version">
                            {{ version.dlversion }}
                          </mat-option>
                        </mat-select> -->
                    </mat-form-field>
                    <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;">
                      <div>
                        <p style="margin-top:25px">
                          <span style="background: #ddd;">bizintel360-</span>
                        </p>
                      </div>
                      <div>
                        <mat-form-field appearance="fill" style="width: 55%;">
                          <mat-label class="bold-label">Index / Table Name</mat-label>
                          <input type="text" matInput formControlName="index_name" id="ib_details_target_index_name"
                            readonly required>
                        </mat-form-field>
                      </div>
                    </div>
                    <mat-label>Action Type</mat-label>
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <mat-select formControlName="action_type" id="ib_details_target_action_type">
                        <mat-option *ngFor="let type of actionTypeListDLO" [value]="type.actionTypevalue">
                          {{ type.actionTypeTitle }}
                        </mat-option>
                      </mat-select>
                      <!-- <input matInput formControlName="action_type" type="text" readonly> -->
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                      *ngIf="datatarget_action_type == 'upsert' || datatarget_action_type == 'update' || datatarget_action_type == 'delete'">
                      <mat-label class="bold-label">Primary Key</mat-label>
                      <input type="text" matInput formControlName="primary_key" id="ib_details_target_primary_key"
                        readonly>
                    </mat-form-field>
                    <mat-label>Indexing Type</mat-label>
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <!-- <input matInput formControlName="indexing_type" type="text" readonly> -->
                      <mat-select formControlName="indexing_type" id="ib_details_target_index_type">
                        <mat-option *ngFor="let type of indexingTypeListDLO" [value]="type.indexTypevalue">
                          {{ type.indexTypeTitle }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </mat-card>
              </div>
            </mat-card>

            <mat-card class="m-card system" *ngIf="bridge_target_type == 4">

              <!-- <label class="ops-lab">Operations Property - Email</label> -->
              <div class="ops-form-body">
                <mat-tab-group class="views-options-data-group-email" fitInkBarToContent mat-stretch-tabs="false"
                  mat-align-tabs="start" animationDuration="0ms" [(selectedIndex)]="indexSelectionEmailTarget">
                  <mat-tab label="Compose">
                    <mat-card class="m-card data-source">
                      <div class="m-body">
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">To</mat-label>
                          <input type="text" matInput formControlName="to" id="ib_details_target_email_to">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Cc</mat-label>
                          <input type="text" matInput formControlName="cc" id="ib_details_target_email_cc">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Bcc</mat-label>
                          <input type="text" matInput formControlName="bcc" id="ib_details_target_email_bcc">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Subject</mat-label>
                          <input type="text" matInput formControlName="subject" id="ib_details_target_email_sub">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Source Key</mat-label>
                          <input type="text" matInput formControlName="source_key" id="ib_details_target_email_sKey">
                        </mat-form-field>
                        <div class="mat-form-field">
                          <!-- <input matInput formControlName="body" id="ib_details_target_email_body" /> -->
                          <ckeditor formControlName="body" [config]="ckEditorConfig" id="ib_details_target_email_body">
                          </ckeditor>
                        </div>
                      </div>
                    </mat-card>
                  </mat-tab>
                  <mat-tab label="Attachment" style="margin-left:5px">
                    <mat-card class="m-card data-source">
                      <div class="m-body">
                        <div class="image-xe profile-image">
                          <div class="file-upload">
                            <p style="color: #000000; padding: 10px 0;">
                              <span>
                                Is Attachment ?
                              </span>
                              <!-- <mat-slide-toggle style="text-align:right;" id="ib_details_target_email_attach_toggle"></mat-slide-toggle> -->
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="m-body"><!-- *ngIf="attachment == 'yes'" -->
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">File Name</mat-label>
                          <input type="text" matInput formControlName="file_name" id="ib_details_target_email_file">
                        </mat-form-field>
                      </div>
                    </mat-card>
                  </mat-tab>
                  <mat-tab label="Settings" style="margin-right:5px">

                    <mat-card class="m-card data-source">
                      <div class="m-body">
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">From</mat-label>
                          <input type="text" matInput formControlName="From" required id="ib_details_target_email_from">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Password</mat-label>
                          <input type="password" matInput formControlName="email_password"
                            id="ib_details_target_email_password" required>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Mail Server</mat-label>
                          <input type="text" matInput formControlName="mailserver" id="ib_details_target_email_mServer"
                            required>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Port Number</mat-label>
                          <input type="text" matInput formControlName="email_port_number"
                            id="ib_details_target_email_port">
                        </mat-form-field>
                      </div>
                    </mat-card>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </mat-card>

            <div class="action-btn-section">
              <button mat-stroked-button matStepperPrevious class="previous" id="ib_details_target_dl_prev_btn">
                <mat-icon matSuffix>west</mat-icon>Previous
              </button>
              <button mat-stroked-button matStepperNext class="next" id="ib_details_target+dl_next_btn">
                Next<mat-icon matSuffix>east</mat-icon>
              </button>
              <button mat-stroked-button matStepperPrevious routerLink="/baseapp/integration" class="previous"
                id="ib_details_target_dl_go_back">
                <mat-icon matSuffix>west</mat-icon>Go Back
              </button>
            </div>
          </form>
        </mat-step>

        <mat-step [stepControl]="summary" [completed]="false">
          <form [formGroup]="summary">
            <ng-template matStepLabel>Summary</ng-template>
            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Integration Bridge</span>
              </mat-card-title>
              <div class="m-body">
                <mat-label>Integration Bridge Name</mat-label>
                <mat-form-field appearance="fill">
                  <input type="text" matInput formControlName="bridge_name" id="dSuminp1">
                </mat-form-field>
              </div>
              <div class="m-body">
                <mat-label>Description</mat-label>
                <mat-form-field appearance="fill">
                  <textarea formControlName="bridge_description" style="height: 150px;" id="dSuminp2"
                    placeholder="Description" matInput cdkTextareaAutosize required></textarea>
                </mat-form-field>
              </div>
            </mat-card>
            <mat-card *ngIf="bridge_source_type != 4" class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Schedule</span>
              </mat-card-title>
              <div>
                <mat-label style="font-weight: 500;">Timer Type</mat-label>
              </div>
              <div class="timer grid">
                <span>Interval</span>
                <div>
                  <mat-slide-toggle formControlName="timertype" id="ib_update_summary_timer_toggle"
                    [checked]="scheduleval">
                  </mat-slide-toggle>
                </div>
                <span>Schedule</span>
              </div>
              <div class="timer">
                <mat-form-field appearance="fill" *ngIf="timertypeval == 'interval'">
                  <mat-label>Interval(in seconds)</mat-label>
                  <input type="number" matInput formControlName="interval" min="1" id="ib_update_summary_interval"
                    (keydown.enter)="$event.preventDefault()">
                  <mat-error *ngIf="summary.get('interval').hasError('pattern')"
                    (keydown.enter)="$event.preventDefault()">
                    Minimum Value Should Be One!
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" *ngIf="timertypeval == 'schedule'">
                  <mat-label>Schedule</mat-label>
                  <!-- (click)="openSchedular()" (keydown.enter)="$event.preventDefault()" -->
                  <input type="text" matInput formControlName="schedule" id="ib_update_summary_schedule"
                    (keydown.enter)="$event.preventDefault()">
                  <mat-error *ngIf="summary.get('schedule').hasError('pattern')">
                    Schedule does not allows negative values!
                  </mat-error>
                </mat-form-field>
                <button type="button" mat-button matSuffix aria-label="Search" (click)="openSchedular()"
                  *ngIf="timertypeval == 'schedule'" style="height: 58px;margin-top: -16px;">
                  <mat-icon
                    style="font-size: 2.125rem;height: 2.125rem;width: 2.125rem;margin-top:-10px">timer</mat-icon>
                </button>
                <br>
                <mat-form-field class="time-zone" appearance="fill" *ngIf="timertypeval == 'schedule'">
                  <mat-label> Time Zone </mat-label>
                  <input type="text" placeholder="Search by country name" aria-label="Time Zone" matInput
                    formControlName="time_zone" [matAutocomplete]="autoTimeZone"
                    (keydown.enter)="$event.preventDefault()">
                  <mat-autocomplete #autoTimeZone="matAutocomplete">
                    <mat-option *ngFor="let timezone of timezones$ | async" [value]="timezone">
                      {{ timezone.timezone }}
                    </mat-option>
                  </mat-autocomplete>
                  <button type="button" mat-button matSuffix aria-label="Search" id="time_zone_clear_btn">
                    <mat-icon>search</mat-icon>
                  </button>
                  <button type="button" mat-button id="time_zone_clear_btn" *ngIf="enableTimeZoneClearIcon" matSuffix
                    aria-label="Clear">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Event Email</span>
                <span class="sub-content">Triggers Email on Start and Stop Action of Integration Bridge</span>
              </mat-card-title>
              <div class="timer grid">
                <mat-label style="font-weight: 500;">To</mat-label>
              </div>
              <mat-card-content class="mc-content">
                <div class="form-container">
                  <div class="selected-group">
                    <span *ngFor="let email of emails">{{email}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Advanced Settings</span>
              </mat-card-title>
              <div>
                <mat-slide-toggle formControlName="toggle" [checked]="showAdvancedSettings"
                  (change)="toggleAdvancedSettings()">
                  <span style="color: red; padding: 20px;">Enable Advanced Settings</span>
                </mat-slide-toggle>
              </div>
              <br>
              <div *ngIf="showAdvancedSettings">
                <div>
                  <mat-label style="font-weight: 500; color: red;">
                    This section is for Advanced Users who understand Cloud Computing and Streaming Techs
                  </mat-label>
                </div>
                <br>
                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>Each Worker Capacity</mat-label>
                    <input type="number" formControlName="sbs" matInput>
                    <mat-error *ngIf="summary.get('sbs').hasError('min') || summary.get('sbs').hasError('max')">
                      Minimum Value Should Be One Thousand And Maximum Value Should Be Fifty Thousand!
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-label>Number of Workers (workers needed for data transportation)</mat-label>
                  <mat-form-field class="mat-dropdown" appearance="outline">
                    <mat-select placeholder="Number of Workers" formControlName="now">
                      <mat-option value="1">1</mat-option>
                      <mat-option value="2">2</mat-option>
                      <mat-option value="4">4</mat-option>
                      <mat-option value="6">6</mat-option>
                      <mat-option value="8">8</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-label>Source Response Wait Time</mat-label>
                  <mat-form-field appearance="fill">
                    <input type="number" formControlName="srwt" matInput>
                    <mat-error *ngIf="summary.get('srwt').hasError('min') || summary.get('srwt').hasError('max')">
                      Minimum Value Should Be Four Thousand And Maximum Value Should Be Ten Thousand!
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>Log Size (in kb)</mat-label>
                    <input type="number" formControlName="logsize" matInput>
                    <mat-error *ngIf="summary.get('logsize').hasError('min')">
                      Minimum value should be 20kb!
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>

            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Summary</span>
                <span class="sub-content">Based on your information you provided here is your summary. Please confirm
                  that the details in each steps are correct to proceed</span>
              </mat-card-title>
              <mat-card-content class="mc-content">
                <div class="form-container">
                  <div class="list-info" *ngIf="bridge_source_type == 1">
                    <span>Data Source</span>
                    <!-- <span>{{isNewSource? dataSource.value.new_bridge_source: dataSource.value.bridge_source}}</span> -->
                    <span>{{bridge_summary_source_name}}</span>
                  </div>
                  <div class="list-info" *ngIf="bridge_source_type != 1">
                    <span>Data Source</span>
                    <span>{{source_name_for_webSocket}}</span>
                  </div>
                  <div class="list-info" *ngIf="bridge_source_type == 1">
                    <span>Source Business Object</span>
                    <span>{{bridge_summary_source_bobj}}</span>
                    <!-- <span>{{isNewSource? dataSource.value.new_bridge_source_business_object:
                      dataSource.value.bridge_source_business_object?.business_obj}}</span> -->
                  </div>
                  <div class="list-info" *ngIf="bridge_target_type == 1">
                    <span>Data Target</span>
                    <span>{{bridge_summary_target_name}}</span>
                    <!-- <span>{{isNewTarget? dataTarget.value.new_bridge_target: dataTarget.value.bridge_target}}</span> -->
                  </div>
                  <div class="list-info" *ngIf="bridge_target_type != 1">
                    <span>Data Target</span>
                    <span>{{bridge_summary_target_name}}</span>
                  </div>
                  <div class="list-info" *ngIf="bridge_target_type == 1">
                    <span>Target Business Object</span>
                    <span>{{bridge_summary_target_bobj}}</span>
                    <!-- <span>{{isNewTarget? dataTarget.value.new_bridge_target_business_object:
                      dataTarget.value.bridge_target_business_object?.business_obj}}</span> -->
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Additional Information</span>
              </mat-card-title>
              <mat-card-content class="mc-content">
                <div class="form-container">
                  <div class="list-info">
                    <span>Created By</span>
                    <span>{{integrationObj?.created_by}}</span>
                  </div>
                  <div class="list-info">
                    <span>Updated By</span>
                    <span>{{integrationObj?.created_by}}</span>
                  </div>
                  <div class="list-info">
                    <span>Created Date</span>
                    <span>{{integrationObj?.created_date | date: 'medium'}}</span>
                  </div>
                  <div class="list-info">
                    <span>Updated Date</span>
                    <span>{{integrationObj?.updated_date | date: 'medium'}}</span>
                  </div>
                  <div class="list-info">
                    <span>Created IP Address</span>
                    <span>{{integrationObj?.created_ip_address}}</span>
                  </div>
                  <div class="list-info" >
                    <span>Updated IP Address</span>
                    <span>{{integrationObj?.updated_ip_address}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <div class="action-btn-section">
              <button mat-stroked-button matStepperPrevious routerLink="/baseapp/integration" class="previous"
                id="dSuminp5">
                <mat-icon matSuffix>west</mat-icon>Go Back
              </button>
            </div>
          </form>
        </mat-step>
      </mat-stepper>
      <div class="about-frame" style="margin-top: 167px">
        <app-about-page *ngIf="hide1024"></app-about-page>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>